// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"5c16653e","297":"3c6701d9","643":"552820d6","959":"4e7abe59"}[chunkId] + ".chunk.js";
};